import React, { useState, useEffect } from 'react';
import useUserAddForm from './useUserAddForm';
import { ContactInfoForm, UserInfoForm } from 'containers/pages/users/components';
import { Grid } from 'components/mui';
import { array, func, string } from 'prop-types';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { setUserFormComplexity } from 'components/onboarding/tour/addUserTourState';

/**
 * @component UserAddForm
 * @param {Object} props
 * @param {string} props.id
 * @param {function} props.onClickForm
 * @param {function} props.handleMode
 * @param {UserGroup[]} props.userGroups
 * @param {string} props.userGroups.userId
 * @param {string} props.userGroups.roleGroupId
 * @returns {JSX.Element}
 */
function UserAddForm({ id, onClickForm, handleMode, userGroups }) {
    const state = useUserAddForm(id, onClickForm, handleMode);

    // 1. Add toggle state here
    const [complexity, setComplexity] = useState("simple");
    const handleComplexityChange = (event, newComplexity) => {
        if (newComplexity !== null) setComplexity(newComplexity);
    };

    // Publish the view complexity so the Add-User walkthrough can gate its
    // "choose Full view" step; reset on unmount so it can't stick.
    useEffect(() => {
        setUserFormComplexity(complexity);
    }, [complexity]);
    useEffect(() => () => setUserFormComplexity("simple"), []);

    // NEW: Folder permissions state (moved from UserInfoForm integration)
    const [draftFolderPermissions, setDraftFolderPermissions] = useState([]);

    const handleFolderPermissionsSet = (permissions) => {
        console.log("📝 UserAddForm: Draft permissions received:", permissions);
        setDraftFolderPermissions(permissions);
    };

    // Enhanced create user function (will be implemented later)
    const handleCreateUserWithPermissions = () => {
        state.onCreateUserWithPermissions(draftFolderPermissions);
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12} md={8}>
                    <ContactInfoForm
                        user={state.user}
                        valid={state.valid}
                        addressType={state.addressType}
                        dispatch={state.dispatch}
                        handleForm={state.handleForm}
                        onChangeValid={state.onValid}
                        complexity={complexity}
                        onComplexityChange={handleComplexityChange} 
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <UserInfoForm
                        user={state.user}
                        valid={state.valid}
                        canNotSave={state.canNotSave}
                        handleForm={state.handleForm}
                        onClickCreateUser={handleCreateUserWithPermissions} // ENHANCED VERSION
                        onResetBtn={state.onResetBtn}
                        userGroups={userGroups}
                        complexity={complexity}
                        // NEW FOLDER PERMISSIONS PROPS
                        mode="create"
                        userId={null}
                        onFolderPermissionsSet={handleFolderPermissionsSet}
                    />
                </Grid>
                <LoadingBackdrop open={state.isLoading} />
            </Grid>
        </>
    );
}

UserAddForm.propsType = {
    id: string,
    onClickForm: func,
    handleMode: func,
    userGroups: array,
};

export default UserAddForm;
